import toastMessage from "./toastMessage";

export const validateDonorNumber = (value, language, showToast = true) => {
  const hasNonNumeric = /\D/.test(value);
  const numericValue = value.replace(/\D/g, "").slice(0, 7);

  let error = null;

  if (hasNonNumeric && value !== "") {
    error = language.donor_number_numeric_only;
    if (showToast) {
      toastMessage("error", error);
    }
  } else if (numericValue !== "" && numericValue.length < 7) {
    error = language.donor_number_invalid;
  } else if (numericValue.length === 7 && !/^\d{7}$/.test(numericValue)) {
    error = language.donor_number_invalid;
  }

  return {
    value: numericValue,
    error: error,
  };
};

export const validateDonorNumberForSubmission = (
  donorNumber,
  category,
  language
) => {
  if (category !== "repeatDonor") return null;

  if (!donorNumber || donorNumber === "") {
    return language.donor_number_required;
  }

  if (donorNumber.length !== 7 || !/^\d{7}$/.test(donorNumber)) {
    return language.donor_number_invalid;
  }

  return null;
};
